"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceManager = void 0;
const MMMConfigurationDatabase_1 = require("../configuration/indexDb/MMMConfigurationDatabase");
const Resource_1 = require("./Resource");
const tsyringe_1 = require("tsyringe");
let ResourceManager = class ResourceManager {
    constructor(logger, db) {
        this.logger = logger;
        this.db = db;
    }
    addResource(resource) {
        return __awaiter(this, void 0, void 0, function* () {
            let id = yield this.db.resource.add(resource);
            return yield this.getResource(id);
        });
    }
    deleteResource(resourceId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.db.resource.delete(resourceId);
        });
    }
    getResource(resourceId) {
        return __awaiter(this, void 0, void 0, function* () {
            this.db.resource.mapToClass(Resource_1.Resource);
            let resource = yield this.db.resource.get(resourceId);
            if (resource == null) {
                throw Error(`Resource id ${resourceId} does not exist.`);
            }
            else
                return resource;
        });
    }
    getAllResources() {
        return __awaiter(this, void 0, void 0, function* () {
            this.db.resource.mapToClass(Resource_1.Resource);
            return yield this.db.resource.toArray();
        });
    }
    getAllBlobResources() {
        return __awaiter(this, void 0, void 0, function* () {
            let resources = yield this.getAllResources();
            return resources.filter(resource => resource.resourceType === Resource_1.ResourceType.Blob);
        });
    }
    getAllUrlResources() {
        return __awaiter(this, void 0, void 0, function* () {
            let resources = yield this.getAllResources();
            return resources.filter(resource => resource.resourceType === Resource_1.ResourceType.Url);
        });
    }
};
ResourceManager = __decorate([
    tsyringe_1.injectable(),
    __metadata("design:paramtypes", [Object, MMMConfigurationDatabase_1.MMMConfigurationDatabase])
], ResourceManager);
exports.ResourceManager = ResourceManager;
//# sourceMappingURL=ResourceManager.js.map